import _ from 'lodash';
import Service from './abstract';
import accountsService from './accounts';
import currenciesService from './currencies';

const withAccountsOrigin = 'accounts,accountOrigin,accountOrigin.wallet,accountOrigin.currency,accountOrigin.currency.attributes,accountOrigin.currency.attributes.attribute';
const withAccountsDestination = 'accountDestination,accountDestination.wallet,accountDestination.currency,accountDestination.currency.attributes,accountDestination.currency.attributes.attribute';
const defaultWith = `childs,childs.transfer,childs.transfer.type,type,status,currency,currency.attributes,currency.attributes.attribute,${withAccountsOrigin},${withAccountsDestination}`;
const defaultOptionsFind = {
    order: 'created_at-DESC',
    with: defaultWith,
    withUsers: 'person,person.attributes,person.attributes.attribute,person.documents,person.documents.type'
};
const defaultPartner = {
    with: 'status,type,accounts,accountDestination,voucher'
};

class Transfers extends Service {
    constructor () {
        super('transfers');
    }

    get defaultOptionsFind () {
        return _.merge({}, super.defaultOptionsFind, defaultOptionsFind);
    }

    getByAccount (id, options = {}) {
        return this.get({
            url: `${this.basePath}/accounts/${id}/transfers`,
            qs: _.defaultsDeep({}, options, defaultOptionsFind)
        }).then(transfers => this.normalizeAll(transfers));
    }

    getByAccountTotals (id, options = {}) {
        return this.get({
            url: `${this.basePath}/accounts/${id}/transfers`,
            qs: options
        }).then(transfers => this.normalizeAll(transfers));
    }

    getTransferTotals (options = {}) {
        return this.get({
            url: `${this.basePath}/transfers`,
            qs: options
        }).then(transfers => this.normalizeAll(transfers));
    }

    types (options = {}) {
        options.url = `${this.basePath}/transfers/types`;
        return this.get(options);
    }

    rules (options = {}) {
        return this.get({
            url: `${this.basePath}/rules`,
            qs: _.defaultsDeep({ tiny: false }, options)
        });
    }

    getRuleById (id) {
        return this.get({
            url: `${this.basePath}/rules/${id}`,
            qs: { tiny: false }
        });
    }

    getPartnerTransfers (options = {}) {
        return this.get({
            url: `${this.basePath}/transfers`,
            qs: _.defaultsDeep({}, options, defaultPartner)
        });
    }

    getHealth (options = {}) {
        return this.get({
            url: `${this.basePath}/health`,
            qs: options
        });
    }

    postTransactions (options = {}) {
        return this.post({
            url: `${this.basePath}/views/transactions`,
            data: options
        });
    }

    normalize (transfer) {
        if (_.isNil(transfer)) {
            return transfer;
        }

        // Prepare default properties
        transfer = super.normalize(transfer);

        // Prepare accounts
        if (transfer.accounts) {
            if (transfer.accounts.origin) {
                transfer.accounts.origin = accountsService.normalize(transfer.accounts.origin);
            }
            if (transfer.accounts.destination) {
                transfer.accounts.destination = accountsService.normalize(transfer.accounts.destination);
            }
        }

        // Prepare currency
        if (transfer.currency) {
            transfer.currency = currenciesService.normalize(transfer.currency);
        }
        return transfer;
    }
}

export default new Transfers();
